import React, { createContext, useContext } from 'react';

export type SetHeaderTabs = (node: React.ReactNode) => void;

const DashboardHeaderContext = createContext<SetHeaderTabs | null>(null);

export function useDashboardHeaderTabs() {
  return useContext(DashboardHeaderContext);
}

export const DashboardHeaderContextProvider = DashboardHeaderContext.Provider;
